import { createTheme } from "@material-ui/core";

export const GENOME_THEME = createTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#F3F2FC",
    },
    secondary: {
      main: "#2820D1",
    },
    selected: {
      main: "#FF3185",
    },
    text: {
      main: "grey",
    },
    background: {
      paper: "#fff",
    },
    disabled: {
      main: "#BBBDBD",
      text: "#A2A2A2 !important",
    },
  },
  primaryPinkButton: {
    borderRadius: 30,
    backgroundColor: "#FF3185",
    color: "white !important",
    padding: "0.5rem 3rem",
    height: 42,
    "&:hover": {
      border: "2px solid #2820D1",
      backgroundColor: "white",
      color: "#2820D1 !important",
    },
    "&:disabled": {
      color: "#A2A2A2 !important",
      backgroundColor: "#BDBDBD",
      border: "2px solid #BDBDBD",
    },
  },
  secondaryPinkButton: {
    borderRadius: 30,
    border: `2px solid #FF3185`,
    color: `#FF3185 !important`,
    padding: "0.5rem 3rem",
    backgroundColor: "white",
    height: 42,
    "&:hover": {
      border: `2px solid #2820D1`,
      backgroundColor: "#2820D1",
      color: "white !important",
    },
    "&:disabled": {
      color: "#A2A2A2 !important",
      backgroundColor: "#BDBDBD",
      border: "2px solid #BDBDBD",
    },
  },
  iconButtonDisable: {
    height: 40,
    width: 40,
    placeItems: "center",
    display: "grid",
    color: "#A2A2A2",
    backgroundColor: "#BDBDBD",
    border: "2px solid #BDBDBD",
    borderRadius: 30,
  },

  iconButton: {
    borderRadius: 30,
    border: `2px solid #FF3185`,
    color: `#FF3185 !important`,
    backgroundColor: "white",
    placeItems: "center",
    display: "grid",
    position: "relative",
    height: 40,
    width: 40,
    "&:hover": {
      border: `2px solid #2820D1`,
      backgroundColor: "#2820D1",
      color: "white !important",
    },
    "&:disabled": {
      color: "#A2A2A2 !important",
      backgroundColor: "#BDBDBD",
      border: "2px solid #BDBDBD",
    },
  },
  primaryBlueButton: {
    borderRadius: 30,
    width: "100%",
    backgroundColor: "#2820D1",
    color: "white !important",
    padding: "0.5rem 3rem",
    height: 42,
    "&:hover": {
      border: "2px solid #FF3185",
      backgroundColor: "white",
      color: "#FF3185 !important",
    },
    "&:disabled": {
      color: "#A2A2A2 !important",
      backgroundColor: "#BDBDBD",
      border: "2px solid #BDBDBD",
    },
  },
  secondaryBlueButton: {
    width: "100%",
    borderRadius: 30,
    border: `2px solid #2820D1`,
    color: `#2820D1 !important`,
    padding: "0.5rem 3rem",
    backgroundColor: "white",
    height: 42,
    "&:hover": {
      border: `2px solid #FF3185`,
      backgroundColor: "#FF3185",
      color: "white !important",
    },
    "&:disabled": {
      color: "#A2A2A2 !important",
      backgroundColor: "#BDBDBD",
      border: "2px solid #BDBDBD",
    },
  },
});
